import { AGENT_PERMISSIONS_ACTIONS } from "../../constants";

const initialState = {
    allowPlayRecordsOnCallHistory: false,
    allowChangeDialing: false
}

const stateAgentPermissions = (state = initialState, action) => {
    switch(action.type){
        case AGENT_PERMISSIONS_ACTIONS.ALLOW_PLAY_RECORDS_ON_CALL_HISTORY:
            return {...state, allowPlayRecordsOnCallHistory: action.allowPlayRecordsOnCallHistory}
        case AGENT_PERMISSIONS_ACTIONS.SET_ALLOW_CHANGE_DIALING:
            return {
              ...state,
              allowChangeDialing: action.payload
            }
          break;

        
        default:
            return state;
    }
}

export default stateAgentPermissions;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_agent_permissions.js